module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-services-sections"
  }, [_c('div', {
    staticClass: "custom-services-sections__title"
  }, [_vm._v("Services")]), _c('div', {
    staticClass: "custom-services-sections__container"
  }, _vm._l((_vm.props), function(section, i) {
    return _c('div', {
      staticClass: "custom-services-sections__section",
      class: {
        'custom-services-sections__section--flip': i % 2
      }
    }, _vm._l((section.sub_section), function(sub, j) {
      return _c('div', {
        staticClass: "custom-services-sections__sub-section",
        class: {
          'custom-services-sections__sub-section--bg': j % 2, 'custom-services-sections__sub-section--overlay': j === 0 && i !== 1
        }
      }, [_c('div', {
        staticClass: "custom-services-sections__overlay"
      }), _c('div', {
        staticClass: "custom-services-sections__sub-section--container"
      }, [_c('div', {
        staticClass: "custom-services-sections__container--body"
      }, [_c('div', {
        staticClass: "custom-services-sections__sub-text"
      }, [_c('div', {
        staticClass: "custom-services-sections__sub-title",
        domProps: {
          "innerHTML": _vm._s(sub.title)
        }
      }), (!sub.tabs) ? _c('div', {
        staticClass: "custom-services-sections__sub-body",
        domProps: {
          "innerHTML": _vm._s(sub.body)
        }
      }) : _vm._e()]), (sub.tabs) ? _c('div', {
        staticClass: "custom-services-sections__sub-tabs"
      }, _vm._l((sub.tab_section), function(tab, i) {
        return _c('div', {
          staticClass: "custom-services-sections__tabs"
        }, [_c('div', {
          staticClass: "custom-services-sections__tab--title",
          domProps: {
            "innerHTML": _vm._s(tab.header)
          },
          on: {
            "click": function($event) {
              return _vm.showAccordion(i)
            }
          }
        }), _c('transition', {
          attrs: {
            "name": "fade"
          }
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.accordion === i),
            expression: "accordion === i"
          }],
          staticClass: "custom-services-sections__tab--body",
          domProps: {
            "innerHTML": _vm._s(tab.body)
          }
        })])], 1)
      }), 0) : _vm._e()]), _c('div', {
        staticClass: "custom-services-sections__container--image"
      }, [_c('div', {
        staticClass: "custom-services-sections__image",
        style: ({
          backgroundImage: 'url(' + sub.image + ')'
        })
      })])])])
    }), 0)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665a856e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-services-sections/custom-services-sections.pug
// module id = 660
// module chunks = 1